import Card from "components/card";
import React, { useMemo,useState } from "react";
import "../../../../assets/css/App.css"; 
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { FaRegWindowClose } from "react-icons/fa";
import { FaFileAlt } from "react-icons/fa";
import  { FILES_URL } from '../../../../configs/AppConfig';
const ColumnsTable = (props) => {
  const [isLoading , setIsLoading] = useState(false);
  const { columnsData, tableData } = props;
  const [feedbackInfo, setFeedbackInfo] = useState(false);
  const [reviewPPop, setReviewPop] = useState(null);

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = 50;

    const viewId = (cell)=>{
    setReviewPop(cell);
    setFeedbackInfo(true);
  }
const openFile = () => {
      window.open(`${FILES_URL}${reviewPPop.presentation?.url}`, "_blank"); // PDF must be in public folder
    };
    
const openStl = () => {
      window.open(`${FILES_URL}${reviewPPop.stl?.url}`, "_blank"); 
    };


  return (
    <Card extra={"w-full pb-10 p-4 h-full"}>
      <div className="mt-2 tableOverFlow">
        <table {...getTableProps()} className="w-full">
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={index}
                    className="border-b border-gray-200 pr-14 pb-[10px] text-start dark:!border-navy-700"
                  >
                    <div className="flex w-full justify-between pr-10 text-xs tracking-wide text-gray-600">
                      {column.render("Header")}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
        {data[0] ? <tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => {
                    let data;
                    if (cell.column.Header === "DUE DATE") {
                      data = (
                        <p className="mr-[10px] text-sm font-semibold text-navy-700 dark:text-white">
                          {cell.value?.substring(0, 10)}
                        </p>
                      );
                    } else if (cell.column.Header === "STATUS") {
                        if (!cell.value) {
                        data = (
                          <p className="text-sm font-bold text-yellow-500">
                            Pending
                          </p>
                        );
                      } else if (cell.value === "Graded") {
                        data = (
                          <p className="text-sm font-bold text-green-500">
                            {cell.value}
                          </p>
                        );
                      } else if (cell.value === "Ungraded") {
                        data = (
                          <p className="text-sm font-bold text-red-500">
                            {cell.value}
                          </p>
                        );
                      }  
                     else {
                        data = (
                          <p className="text-sm font-bold dark:text-white">
                            {cell.value}
                          </p>
                        );
                     } 
                  } else if (cell.column.Header === "POINTS") {
                      data = (
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          {cell.value}
                        </p>
                      );
                    } else if (cell.column.Header === "DETAILS") {
                      data = (
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                         {cell.row.original?.feedback ? <button class="tableViewBtn" onClick={() => {viewId(cell.row.original)}}>View</button> : <button className="tableViewBtnDs" disabled>View</button>}
                        </p>
                      );
                    }
                    return (
                      <td
                        className="pt-[14px] sm:text-[14px]"
                        {...cell.getCellProps()}
                        key={index}
                      >
                        {data}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>: <tbody> <tr><td className="w-[5px] h-[5px]"> 
            {isLoading ? <div class="loader"></div> : <h2 className="noDataFound">No Feedback Yet</h2>}
          </td></tr> </tbody>}
        </table>
      </div>
      { feedbackInfo ? <div className="modal"> <div className="addFeedBackPop w-[450px]">
                      <div className="addFeedBack"> 
                        <span className="Review-grade" 
                      style={{
                      background: reviewPPop.feedback.status === "Graded" ? "#62CA4E" : "#f53939",
                    }} >{reviewPPop.feedback.status}</span>
                        <button id="popIcon" onClick={()=>{setFeedbackInfo(false)}}>
                        <FaRegWindowClose className="w-full h-full	"/>
                      </button> </div>
                        <div className="feedbackInpts">
                          <span className="feedbackSpan">Feedback</span>
                          <div className="feedbackDev">
                            {reviewPPop.feedback.feedbackText}
                          </div>
                        </div>
                        <div className="feedbackSpan">
                          <span>Submitted Files</span>
                        </div>
                      <div className="fileReviews" onClick={() => openFile(reviewPPop)}> <FaFileAlt className="w-[25px] h-[25px]" /> <span>Assignment PDF </span>
                      </div>
                      <div className="fileReviews" onClick={() => openStl(reviewPPop)}> <FaFileAlt className="w-[25px] h-[25px]" /> <span>Assignment STL </span>
                       </div>
      
                      </div>
                        </div> : null}
    </Card>
  );
};

export default ColumnsTable;
